var map = {
	"./aethir.png": [
		242,
		242
	],
	"./arkefi.svg": [
		476,
		476
	],
	"./bevm.png": [
		97,
		97
	],
	"./bonusblock.svg": [
		802,
		802
	],
	"./credbull.png": [
		68,
		68
	],
	"./elixir.png": [
		376,
		376
	],
	"./gunzilla.svg": [
		60,
		60
	],
	"./kasu.svg": [
		745,
		745
	],
	"./kindred.png": [
		586,
		586
	],
	"./kintsu.webp": [
		258,
		258
	],
	"./kip.png": [
		949,
		949
	],
	"./kokodi.svg": [
		469,
		469
	],
	"./lingo.png": [
		658,
		658
	],
	"./magnetai.png": [
		253,
		253
	],
	"./metaxseed.svg": [
		491,
		491
	],
	"./moemate.svg": [
		179,
		87
	],
	"./monadpad.svg": [
		295,
		295
	],
	"./nibiru.svg": [
		964,
		964
	],
	"./nuklai.png": [
		696,
		696
	],
	"./qorpo.svg": [
		98,
		98
	],
	"./readygg.png": [
		390,
		390
	],
	"./shrapnel.png": [
		820,
		820
	],
	"./somo.png": [
		606,
		606
	],
	"./velar.png": [
		495,
		495
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 977;
module.exports = webpackAsyncContext;